import script from "./ChartWindow.vue?vue&type=script&setup=true&lang=js"
export * from "./ChartWindow.vue?vue&type=script&setup=true&lang=js"

import "./ChartWindow.vue?vue&type=style&index=0&id=a13d8976&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a13d8976"]])

export default __exports__